import React, { useState } from "react";
import { Text, Popover, TextInput, Button, Group, ActionIcon, ScrollArea } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import { displayEmoji } from "../../../../utils/Emoji";

export default function FilterDropdownFieldSelector({
  type,
  filters,
  onSelectFilter,
  TargetComponent,
  onPressCreateFilter,
  onClearSort
}) {
  const [opened, setOpened] = useState(false);
  const [search, setSearch] = useState("");

  const filteredData = Array.isArray(filters) ? filters.filter((item) => {
    return String(item.name).toLowerCase().includes(search.toLowerCase());
  }) : [];

  const isEmpty = filteredData.length === 0;
  const isSort = typeof onClearSort === "function";

  return (
    <Popover
      opened={opened}
      onClose={() => setOpened(false)}
      spacing={5}
      width={250}
      position="bottom"
      placement="start"
      target={
        TargetComponent ? (
          <TargetComponent onClick={() => setOpened(!opened)} />
        ) : (
          <Button
            variant="default"
            radius="md"
            sx={{ border: "none" }}
            size="xs"
            onClick={isEmpty ? onPressCreateFilter : () => setOpened(true)}
          >
            <Text size="xs" color="grey">+ {isEmpty ? "Create" : "Add"} property</Text>
          </Button>
        )
      }
    >
      <Group spacing={0}>
        <TextInput
          placeholder={isSort ? "Sort by..." : "Filter by..."}
          value={search}
          size="xs"
          onChange={(e) => setSearch(e.currentTarget.value)}
          m={5}
          sx={{ flex: 1 }}
        />
        {(isSort || type === "tags") && (
          <ActionIcon onClick={onClearSort}>
            <FontAwesomeIcon icon={solid("xmark")} color="grey" size="sm" />
          </ActionIcon>
        )}
      </Group>
      <ScrollArea style={{ height: filteredData.length > 5 ? 200 : null }} type="scroll" offsetScrollbars>
        {filteredData.map((filter, key) => (
          <Group
            key={key}
            spacing={0}
            p={5}
            my={5}
            onClick={() => {
              setOpened(false);
              setSearch("");
              if (typeof onSelectFilter === "function") {
                onSelectFilter({...filter, shouldOpenDropdown: true});
              }
            }}
            sx={{ flex: 1, cursor: "pointer", borderRadius: 4, '&:hover': { backgroundColor: '#f5f5f5' } }}
          >
            <Text size="sm" sx={{ width: 16 }} align="center">
              {displayEmoji(filter.emojicon, "grey")}
            </Text>
            <Text color="grey" size="xs" pl={10} lineClamp={1} sx={{ flex: 1 }}>
              {filter.name}
            </Text>
          </Group>
        ))}
      </ScrollArea>
    </Popover>
  );
}